import Routes from '../data/routes'
import Cart from '../typings/Cart'
import Order from '../typings/Order'

import mapCheckoutDataToCheckoutStepsFlags from './map-checkout-data-to-checkout-steps-flags'

const calculateCheckoutSteps = (data: Cart | Order) => {
  const steps = []
  const { hasAdditionalInformation, hasSomethingToPay, hasBufferPage, isOrderPaid } =
    mapCheckoutDataToCheckoutStepsFlags(data)

  if (data.__typename === 'Cart') {
    steps.push(Routes.CHOOSE_PRODUCT)

    if (hasBufferPage) {
      steps.push(Routes.REVIEW_INFORMATION)
    }

    if (hasAdditionalInformation) {
      steps.push(Routes.ADDITIONAL_INFORMATION)
    }

    if (hasSomethingToPay) {
      steps.push(Routes.PAYMENT)
    }

    steps.push(Routes.CONFIRMATION)
  } else {
    if (hasSomethingToPay && !isOrderPaid) {
      steps.push(Routes.PAYMENT)
    }

    steps.push(Routes.CONFIRMATION)
  }

  return steps
}

export default calculateCheckoutSteps
